module.exports = __webpack_public_path__ + "static/media/Logo-t.2fc0c58d.svg";